export default "__VITE_ASSET__CFMgs03T__"